import Alpine from 'alpinejs'
import { throttle } from '@js/util/helpers.js'

Alpine.data('throttle', throttle)
